// extracted by mini-css-extract-plugin
module.exports = {"personIcon":"PersonIcon_personIcon__3WEKK","size32":"PersonIcon_size32__2Mfk5","size48":"PersonIcon_size48__3BAFa"};